import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { useState } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Blog from './pages/Blog';
import ArticlePage from './pages/ArticlePage';
import About from './pages/About';
import Contact from './pages/Contact';
import ScrollToTop from "./components/ScrollToTop";
import AppointmentModal from './components/AppointmentModal';

// ✅ Google Analytics Components
import GoogleAnalytics from "./GoogleAnalytics";
import TrackPageView from "./TrackPageView";

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Router>
      {/* Google Analytics */}
      <GoogleAnalytics />
      <TrackPageView />

      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Header onOpenAppointment={() => setIsModalOpen(true)} />
        
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home openModal={() => setIsModalOpen(true)} />} />
            <Route path="/services" element={<Services openModal={() => setIsModalOpen(true)} />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/article/:slug.php" element={<ArticlePage />} />
            <Route path="/about" element={<About openModal={() => setIsModalOpen(true)} />} />
            <Route path="/contact" element={<Contact openModal={() => setIsModalOpen(true)} />} />

            <Route
              path="*"
              element={
                <div className="min-h-screen flex flex-col items-center justify-center text-center p-6">
                  <h1 className="text-5xl font-bold mb-4 text-red-600">404</h1>
                  <p className="text-xl mb-6">Oops! Page not found.</p>
                  <Link to="/" className="text-blue-600 hover:underline">
                    Go back to Home
                  </Link>
                </div>
              }
            />
          </Routes>
        </main>
        <Footer />
        
        <AppointmentModal 
          isOpen={isModalOpen} 
          onClose={() => setIsModalOpen(false)} 
        />
      </div>
    </Router>
  );
}

export default App;
